import React from "react";
import { Col, Container, Row } from "reactstrap";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid>
          <Row>
            <Col sm={6}></Col>
            <Col sm={6}>
              <div className="text-sm-end d-none d-sm-block">
                {new Date().getFullYear()} © PT TELKOMSEL.
              </div>
            </Col>
          </Row>
        </Container>
        <Row>
          <Col lg={4}>
            <table className="table table-bordered ">
              <thead>
                <tr style={{ backgroundColor: "#82cbef" }}>
                  <th scope="col" className="text-center">
                    Uraian
                  </th>
                  <th scope="col" className="text-center">
                    Kaps.60
                  </th>
                  <th scope="col" className="text-center">
                    Kaps.45
                  </th>
                  <th scope="col" className="text-center">
                    Kaps.30
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row" className="d-flex justify-content-center ">
                    <div
                      style={{
                        height: "20px",
                        width: "20px",
                        backgroundColor: "#538ed7",
                      }}
                    ></div>
                  </th>
                  <td className="text-center">≤ 125K</td>
                  <td className="text-center">≤ 100K</td>
                  <td className="text-center">≤ 90K</td>
                </tr>
                <tr>
                  <th scope="row" className="d-flex justify-content-center ">
                    <div
                      style={{
                        height: "20px",
                        width: "20px",
                        backgroundColor: "#fceb34",
                      }}
                    ></div>
                  </th>
                  <td className="text-center">126K - 225K</td>
                  <td className="text-center">101K - 190K</td>
                  <td className="text-center">96K - 165K</td>
                </tr>
                <tr>
                  <th scope="row" className="d-flex justify-content-center ">
                    <div
                      style={{
                        height: "20px",
                        width: "20px",
                        backgroundColor: "#f94334",
                      }}
                    ></div>
                  </th>
                  <td className="text-center">{"> 226K"}</td>
                  <td className="text-center">{"> 191K"}</td>
                  <td className="text-center">{"> 166K"}</td>
                </tr>
              </tbody>
            </table>
          </Col>
          <Col lg={8}></Col>
        </Row>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
